
import { Component, OnInit, OnDestroy } from '@angular/core';
import { RouterModule, ActivatedRoute, Router } from '@angular/router';
import { AlertNotificationService } from 'src/app/services/alert-notification.service';
import { ProjectsService } from 'src/app/services/api/projects.service';
import { MainLayoutService } from 'src/app/services/main-layout.service';
import { ProjectsAccordionComponent } from '../components/projects-accordion/projects-accordion.component';
import { RouteService } from 'src/app/services/route.service';
import { AccessControlService } from 'src/app/services/access-control.service';
import { Subscription } from 'rxjs';
import { ProjectsFinanceAuthorizationComponent } from '../components/projects-finance-authorization/projects-finance-authorization.component';

@Component({
  selector: 'app-projects-detail-page',
  imports: [RouterModule, ProjectsAccordionComponent, ProjectsFinanceAuthorizationComponent],
  templateUrl: './projects-detail-page.component.html',
  styleUrl: './projects-detail-page.component.scss'
})
export class ProjectsDetailPageComponent implements OnInit, OnDestroy {
  projectId?: string;
  project: any = {};
  canEditProject = false;
  canViewFinance = false;
  private subscriptions = new Subscription();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private projectsService: ProjectsService,
    private alertNotificationService: AlertNotificationService,
    private mainLayoutService: MainLayoutService,
    private routeService: RouteService,
    private accessControlService: AccessControlService
  ) { }

  ngOnInit(): void {
    this.subscriptions.add(
      this.mainLayoutService.activeProfile$.subscribe(profileCode => {
        this.canEditProject = this.accessControlService.hasFeatureActionAccess(profileCode, 'PROJECTS_LIST', 'modify');
        this.canViewFinance = this.accessControlService.hasFeatureActionAccess(profileCode, 'PROJECTS_FINANCE', 'view');
      })
    );
    const projectId = this.route.snapshot.paramMap.get('projectId');
    this.projectId = projectId ? projectId : undefined;
    if (projectId) {
      this.loadProjectData(projectId);
    }     
  }


  loadProjectData(projectId: string): void {
    this.projectsService.detail(Number(projectId)).subscribe({
      next: (response) => {
        if (response.status.code === 200) {
          this.project = response.data.project;
          this.mainLayoutService.setRelatedCodeItem(this.project?.code || null);
          this.mainLayoutService.setClientCompanyName(this.project?.clientCompanyName || null);
        }
      },
      error: (error) => {
        console.error('Error loading project:', error);
        this.alertNotificationService.error('Error loading project data');
      }
    });
  }

  goToEditProject(): void {
    if (!this.projectId) {
      return;
    }
    this.routeService.projectsUpdate(Number(this.projectId));
  }
  
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this.mainLayoutService.setClientCompanyName(null);
  }

}
